const REACT_APP_JAN_URL = process.env.REACT_APP_JAN_URL;
const REACT_APP_JAN_KEY = process.env.REACT_APP_JAN_KEY;

const fetchJan = async ({ uri }: any) => {
  const response = await fetch(`${REACT_APP_JAN_URL}/${uri}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Token: `${REACT_APP_JAN_KEY}`,
    },
  });

  if (response.status !== 200) {
    return Promise.reject();
  }

  return response.json();
};

export default fetchJan;
